import { toast } from "react-toastify";

import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDBBRefreshQuery = (appointment_id: number) => {
  const { isFetching, refetch } = useTypedQuery({
    queryKey: AppointmentDetailsKeys.dbbRefreshedCar,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { id: appointment_id }, baseUrl)).data,
    enabled: false
  });

  const refreshDBB = async () => {
    const { data: car, error } = await refetch();
    if (error) return toast.error(error.message);
    if (!car) return;

    const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
    if (!appointment || appointment.id !== appointment_id) return;

    typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, car: { ...appointment.car, ...car } });
  };

  return { refreshDBB, isFetching };
};
